import React, { Component } from 'react'
import { Container, Table, Button, Spinner, Row, Col } from 'react-bootstrap'
import { withRouter } from 'react-router-dom'
import { AdminNav, Loading } from '../../helpers';
import axios from 'axios'
import { convertRiceTypeENToTH, addCommaInNumber } from '../../helpers/function'

class CheckWeightTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listInComplete: false,
      inCompleteLoading: true,
      completedLoading: false,
      CompanyList: [],
      riceTypeIDAndName: [],
      filterList: [],
      onlyGreen: false
    }
    this.handleTableClick = this.handleTableClick.bind(this)
    this.searchJob = this.searchJob.bind(this)
    this.handleFilter = this.handleFilter.bind(this)
    this.searchLicense = this.searchLicense.bind(this)
    this.showOnlyGreen = this.showOnlyGreen.bind(this)
  }
  componentDidMount() {
    let viewAllSurveyRequestSheetByDate = fetch(`https://backend1.riceinspections.com/testAA?timeValue=${this.props.location.state.timeValue || new Date()}`).then((res) => {
      return res.json()
    })
    let viewAllCompany = fetch(`https://backend1.riceinspections.com/testAB`).then((res) => {
      return res.json()
    })
    let viewAllCheckWeightComplete = axios.post(
      'https://backend1.riceinspections.com/testHA',
      {
        data: { 'timeValue': this.props.location.state.timeValue || new Date() },
      }
    ).then((res) => {
      return res['data']
    })
    let RequestJobComplete = fetch('https://backend1.riceinspections.com/testB').then((res) => {
      return res.json()
    })
    let viewAllOfficer = fetch('https://backend1.riceinspections.com/testC').then((res) => {
      return res.json()
    })
    let viewAllRiceTypeIDAndNamePromise = fetch('https://backend1.riceinspections.com/testE').then((res) => {
      return res.json()
    })

    Promise.all([viewAllSurveyRequestSheetByDate, viewAllCompany, viewAllCheckWeightComplete, RequestJobComplete, viewAllOfficer, viewAllRiceTypeIDAndNamePromise])
      .then((res) => {
        viewAllSurveyRequestSheetByDate = res[0] || {}
        viewAllCompany = res[1] || {}
        viewAllCheckWeightComplete = res[2] || {}
        RequestJobComplete = res[3] || {}
        viewAllOfficer = res[4] || {}
        viewAllRiceTypeIDAndNamePromise = res[5] || {}

        Object.values(viewAllSurveyRequestSheetByDate).map((data) => {
          Object.values(viewAllCompany).map((companyData) => {
            if (data.companyID == companyData.companyID) {
              data['companyEN'] = companyData.companyNameEN
            }
          })
        })
        console.log(RequestJobComplete)
        let arr = []
        Object.keys(viewAllSurveyRequestSheetByDate).map((title) => {
          if (title !== 'countJobID') {
            // console.log(title, typeof viewAllSurveyRequestSheetByDate[title],RequestJobComplete['message'])
            if (typeof viewAllSurveyRequestSheetByDate[title] == 'object' && !RequestJobComplete['message']) {
              if (!viewAllSurveyRequestSheetByDate['message']) {
                let temp = Object.values(RequestJobComplete).filter((e) => { return e['requestID'] == viewAllSurveyRequestSheetByDate[title]['requestID'] })
                // console.log(temp)
                if (temp.length != 0) {
                  viewAllSurveyRequestSheetByDate[title]['jobID'] = temp[0]['jobID']
                  viewAllSurveyRequestSheetByDate[title]['officerName'] = ''
                  viewAllSurveyRequestSheetByDate[title]['officerName'] = temp[0]['officerID']
                  if (temp[0]?.['officerID2']) {
                    viewAllSurveyRequestSheetByDate[title]['officerName2'] = ''
                    viewAllSurveyRequestSheetByDate[title]['officerName2'] = temp[0]['officerID2']
                  }

                  // console.log(viewAllSurveyRequestSheetByDate[title])
                  arr = arr.concat([viewAllSurveyRequestSheetByDate[title]])
                } else {
                  viewAllSurveyRequestSheetByDate[title]['officerID'] = ''
                }
              }
            }
          }
        })
        console.log(arr)
        Object.values(viewAllOfficer).map((Checker) => {
          let id = Checker['ID']
          arr.forEach((data) => {
            if (data['officerName'] == id) {
              data['officerName'] = `${parseInt(Checker['userName']) + 1}. ${Checker['fName']}`
            }
            if (data['officerName'] == id) {
              data['officerName'] = `${parseInt(Checker['userName']) + 1}. ${Checker['fName']} `
            }
            if (data['officerName'] == '') {
              data['officerName'] = `-`
            }
            if (data['officerName2'] == id) {
              data['officerName2'] = `${parseInt(Checker['userName']) + 1}. ${Checker['fName']}`
            }
            if (data['officerName2'] == id) {
              data['officerName2'] = `${parseInt(Checker['userName']) + 1}. ${Checker['fName']} `
            }
            if (data['officerName2'] == '') {
              data['officerName2'] = `-`
            }

          })
        })
        // console.log(arr)
        let newArr = []
        // console.log(viewAllCheckWeightComplete)
        Object.keys(arr).map((title) => {
          if (title !== 'countJobID') {
            if (typeof arr[title] == 'object' && !viewAllCheckWeightComplete?.message) {
              if (!arr['message']) {
                let temp = []
                if (viewAllCheckWeightComplete) {
                  temp = Object.values(viewAllCheckWeightComplete).filter((e) => {
                    return e['jobID'] == arr[title]['jobID']
                  })
                }
                if (temp.length != 0) {
                  Object.values(arr[title]['description']).map((descriptionData) => {
                    temp.map((tempData) => {
                      if (tempData['licenseID'] == descriptionData['licenseID'] && tempData['subID'] == descriptionData['subID']) {
                        console.log(tempData['subID'])
                        tempData['isComplete'] = true
                        descriptionData['isComplete'] = true
                        Object.keys(tempData).map((tempDataKey) => {
                          if (tempDataKey == 'quantity') {
                            tempData[tempDataKey] /= 1000
                          }
                          descriptionData[tempDataKey] = tempData[tempDataKey]
                        })
                      }else{
                        // tempData['isComplete'] = false
                        // descriptionData['isComplete'] = false
                      }
                    })
                  })
                  // arr[title]['jobID'] = temp[0]['jobID']
                  console.log(temp)
                  arr[title]['checkWeightDescription'] = temp
                  newArr = newArr.concat([arr[title]])
                } else {
                  arr[title]['officerID'] = ''
                }
              }
            }
          }
        })
        // console.log(arr)
        // Object.values(newArr).map((dataNewArr)=>{
        //   if(dataNewArr['checkWeightDescription']){
        //     dataNewArr['checkWeightDescription'].map((dataDes)=>{
        //       // dataDes[0]['licenseID']
        //       // dataDes[0]['subID']
        //     })
        //   }
        // })
        // console.log(viewAllSurveyRequestSheetByDate)
        console.log(arr)
        this.setState({
          ...this.state,
          viewAllSurveyRequestSheetByDate: arr,
          rawData: arr,
          inCompleteLoading: false,
          riceTypeIDAndName: viewAllRiceTypeIDAndNamePromise,
          viewAllCompany: viewAllCompany,
          filterList: arr,
        })
      })
  }
  handleTableClick = (e, idx, jobID) => {

    if (e.target.parentElement.id) {
      let prepData = [this.state.viewAllSurveyRequestSheetByDate[e.target.parentElement.id]['description'][idx]]
      // let newData = this.state.viewAllSurveyRequestSheetByDate[e.target.parentElement.id]
      // newData['description'] = prepData
      // console.log(this.state.viewAllSurveyRequestSheetByDate[e.target.parentElement.id]['companyID'])
      // console.log(this.renderCompany(this.state.viewAllSurveyRequestSheetByDate[e.target.parentElement.id]['companyID']))
      this.props.history.push({
        pathname: '/ValidateCheckWeight',
        state: {
          ...this.state.viewAllSurveyRequestSheetByDate[e.target.parentElement.id],
          timeValue: this.props.location.state.timeValue || new Date(),
          timeShow: this.props.location.state.timeShow || new Date()
        },
        companyNameEN: this.renderCompany(this.state.viewAllSurveyRequestSheetByDate[e.target.parentElement.id]['companyID']),
        rawData: this.state.rawData,
        pageIndex: idx,
        itemIndex: jobID,
        companyAll: this.state.viewAllCompany,
      })

      // console.log(this.state.viewAllSurveyRequestSheetByDate[e.target.parentElement.id]['description'])
      // this.state.viewAllSurveyRequestSheetByDate[e.target.parentElement.id]['description'][0]['licenseID'] = license 
      // console.log(this.state.CheckWeightSheet)

    }

    // this.props.history.push({
    //   pathname: '/CheckWeight',
    //   // state: this.state.viewAllSurveyRequestSheetByDate[e.target.parentElement.id],
    //   date: this.props.location.state.timeValue || new Date() ,
    // })
  }
  newToFixed(v, d) {
    if (`${v}`.indexOf('.') != -1) {
      if (`${v}`.length > 14) {
        return `${v.toFixed(4)}`
      } else {
        return `${v}000000`.slice(0, `${v}`.indexOf('.') + 5)

      }
    } {
      return `${v}.0000`
    }
  }

  renderQuantity(data, idx) {
    if (data['description'][idx]['jobID'] == '5318') {
      console.log(data['description'][idx])
      console.log(data['description'][idx]['quantity'])
    }
    if (data['description'][idx]['quantity']) {
      // return parseFloat(data['description'][idx]['quantity'])
      return this.newToFixed(parseFloat(data['description'][idx]['quantity']), 4)
    } else if (data['description'][idx]['Quantity']) {
      // return parseFloat(data['description'][idx]['Quantity'])
      return this.newToFixed(parseFloat(data['description'][idx]['Quantity']), 4)
    } else {
      return null
    }
  }
  searchJob(e) {
    let jobID = e.target.value
    let SurveyData = this.state.rawData
    if (parseInt(jobID) > 0) {
      let arr = Object.values(SurveyData).filter((d) => {
        return `${d['jobID']}` == `${jobID}`
      })
      this.setState({
        ...this.state,
        viewAllSurveyRequestSheetByDate: arr,
      })
    } else {
      this.setState({
        ...this.state,
        viewAllSurveyRequestSheetByDate: SurveyData
      })
      // console.log(SurveyData)
    }
  }
  searchLicense(e) {
    let licenseID = e.target.value
    let SurveyData = this.state.rawData
    if (licenseID.length == 7) {
      licenseID = `030811${licenseID}`
    }
    if (parseInt(licenseID) > 0) {
      // let arr = Object.values(SurveyData).filter((d) => {
      //   d['description'].filter((dIn)=>{
      //     `${dIn['licenseID']}` == `${licenseID}`
      //   })
      // })
      let arr = []

      Object.values(SurveyData).map((o) => {
        o['description'].map((d) => {
          if (`${d['licenseID']}` == `${licenseID}` && !arr.includes(o)) {
            arr.push(o)
          }
        })
      })
      this.setState({
        ...this.state,
        viewAllSurveyRequestSheetByDate: arr,
      })
    } else {
      this.setState({
        ...this.state,
        viewAllSurveyRequestSheetByDate: SurveyData
      })
      // console.log(SurveyData)
    }
  }
  showOnlyGreen() {
    let SurveyData = this.state.rawData
    let arr = []
    let onlyGreen = this.state.onlyGreen
    console.log(SurveyData)
    if (onlyGreen) {
      this.setState({
        ...this.state,
        viewAllSurveyRequestSheetByDate: Object.values(SurveyData),
        onlyGreen: !this.state.onlyGreen
      })

    } else {
      Object.values(SurveyData).map((o) => {
        let newData = {
          ...o,
          'description': []
        }
        o['description'].map((d) => {
          if (d['isComplete'] == true) {
            newData['description'].push(d)
          }
        })
        arr.push(newData)
      })
      console.log(arr)
      this.setState({
        ...this.state,
        viewAllSurveyRequestSheetByDate: arr,
        onlyGreen: !this.state.onlyGreen
      })

    }
  }


  renderDate(dateObj) {
    let dateParser = new Date(dateObj)
    let day = dateParser.getDate()
    let month = dateParser.getMonth() + 1
    let years = dateParser.getFullYear() + 543
    return `${day}/${month}/${years}`
  }
  renderCompany(companyObj) {
    // console.log(this.state.viewAllCompany)
    let viewAllCompany = this.state.viewAllCompany
    let outputCompany = null
    Object.values(viewAllCompany).map((companyData) => {
      if (companyData['companyNameTH'].replace(/\s/g, '').trim() == companyObj.replace(/\s/g, '').trim()) {
        outputCompany = companyData['companyNameEN']
      }
    })
    if (companyObj == 'ไทยฮาจำกัด') {
      outputCompany = 'THAI HA PUBLIC CO., LTD.'
    } else if (companyObj == 'ไทยฟ้า(2511)จำกัด') {
      outputCompany = 'THAI HUA (2511) CO., LTD.'
    }
    if (outputCompany) {
      return outputCompany
    } else {
      return companyObj
    }
  }
  handleFilter(jobID) {
    let SurveyData = this.state.rawData
    let currentFilter = this.state.currentFilter
    if (jobID == 'all') {
      this.setState({
        ...this.state,
        viewAllSurveyRequestSheetByDate: Object.values(SurveyData),
      })
      return true
    }
    if (jobID == currentFilter) {
      this.setState({
        ...this.state,
        viewAllSurveyRequestSheetByDate: Object.values(SurveyData),
      })
    }
    else {
      let arr = Object.values(SurveyData).filter((d) => {
        return `${d['jobID']}` == `${jobID}`
      })
      this.setState({
        ...this.state,
        viewAllSurveyRequestSheetByDate: arr,
        currentFilter: jobID
      })
    }
  }
  render() {
    if (!this.state.inCompleteLoading) {
      return (
        <Container >
          <AdminNav></AdminNav>
          <Row>
            <Col style={{left:"-5em"}} xs={1}>
              <div style={{ position: "sticky", top: '10em', zIndex: '1', width: '90px', height: '300px', overflowY: 'auto', border: '1.5px solid gray', borderRadius: '10px' }}>

                <p style={{ textDecoration: 'underline', textAlign: 'center' }}> ทะเบียนงาน </p>
                {(() => {
                  if (this.state.viewAllSurveyRequestSheetByDate) {

                    return Object.keys(this.state.filterList).map((dataName, idz) => {
                      let data = this.state.filterList[dataName]
                      if (idz == 0) {
                        return (
                          <div>
                            <div onClick={() => { this.handleFilter('all') }} style={{ width: '100%',cursor:'pointer' }}>
                              <p style={{ fontSize: '13px', textAlign: 'center', marginTop: '-10px' }}><b>{'แสดงทั้งหมด'}</b></p>
                            </div>

                            <div onClick={() => { this.handleFilter(data['jobID']) }} style={{ width: '100%',cursor:'pointer' }}>
                              <p style={{ fontSize: '13px', textAlign: 'center', marginTop: '-10px' }}><b>{data['jobID']}</b></p>
                            </div>
                          </div>
                        )
                      }
                      return (
                        <div onClick={() => { this.handleFilter(data['jobID']) }} style={{ width: '100%',cursor:'pointer' }}>
                          <p style={{ fontSize: '13px', textAlign: 'center', marginTop: '-10px' }}><b>{data['jobID']}</b></p>
                        </div>
                      )
                    })
                  }
                })()
                }
              </div>


            </Col>
            <Col>
              <div style={{ display: 'flex', alignItem: 'center', backgroundColor: 'gray' }}>
                <p style={{ margin: '0 auto', fontSize: '18px', color: 'white' }}><b>สามารถใช้งาน *ทะเบียนงาน*, *เลขทะเบียนงาน* , *ค้นหาใบอนุญาต* และ *แสดงเฉพาะรายการ* ได้แล้ว </b></p>
              </div>

              <div style={{ width: '100%', alignContent: 'center', textAlign: 'center', fontSize: '22px' }}  >
                <p><b>Check Weight ประจำวันที่ {this.renderDate(this.props.location.state.timeValue) || this.renderDate(new Date())}</b></p>
              </div>
              <div style={{ whiteSpace: 'nowrap', width: '100%' }}  >
                <div style={{ display: 'inline-block' }}>
                  <span>เลขทะเบียนงาน</span> &nbsp;&nbsp;
                  <input onChange={this.searchJob}></input>&nbsp;&nbsp;
                </div>
                <div style={{ display: 'inline-block' }}>
                  <span>ค้นหาใบอนุญาต</span> &nbsp;&nbsp;
                  <input placeholder='พิมพ์ได้ทั้งแบบเต็มและย่อ' onChange={this.searchLicense}></input>&nbsp;&nbsp;

                </div>
                <div style={{ float: 'right', display: 'inline-block' }}>
                  <Button onClick={this.showOnlyGreen} >แสดงเฉพาะรายการที่ตรวจ</Button>
                </div>

              </div>


              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

              {/* <Button  onClick={()=>{}}> ปิดงานประจำวัน </Button> */}
              <Table bordered hover style={{ tableLayout: 'fixed' }}>
                <thead>
                  <tr>
                    <th style={{ width: '3.7%', overflow: 'auto', fontSize: '11px' }}>เลขทะเบียนงาน</th>
                    <th style={{ width: '5.7%', overflow: 'auto', fontSize: '11px' }}>ชื่อบริษัทส่งออก</th>
                    <th style={{ width: '4.7%', overflow: 'auto', fontSize: '11px' }}>สถานที่</th>
                    <th style={{ width: '4.7%', overflow: 'auto', fontSize: '11px' }}>เวลาบรรุทก</th>
                    <th style={{ width: '6.7%', overflow: 'auto', fontSize: '11px' }}>ชื่อพาหนะ</th>
                    <th style={{ width: '4.7%', overflow: 'auto', fontSize: '11px' }}>ประเทศปลายทาง</th>
                    <th style={{ width: '5.7%', overflow: 'auto', fontSize: '11px' }}>เลขที่ใบอนุญาต</th>
                    <th style={{ width: '3.7%', overflow: 'auto', fontSize: '11px' }}>รายการที่</th>
                    <th style={{ width: '6.7%', overflow: 'auto', fontSize: '11px' }}>ชนิดข้าว</th>
                    <th style={{ width: '5.7%', overflow: 'auto', fontSize: '11px' }}>ปริมาณ / ตัน</th>
                  </tr>
                </thead>
                <tbody>
                  {(() => {
                    if (this.state.viewAllSurveyRequestSheetByDate) {
                      return Object.keys(this.state.viewAllSurveyRequestSheetByDate).map((dataName, idz) => {
                        // let c = this.state.viewAllSurveyRequestSheetByDate[data]
                        let data = this.state.viewAllSurveyRequestSheetByDate[dataName]
                        if (data === 'requestCount') {
                          return null;
                        } else {
                          // console.log(data)
                          return (Object.values(data['description']).map((output, idx) => {
                            console.log(output)
                            return (
                              <tr id={dataName} onClick={(e) => { this.handleTableClick(e, idx, data['jobID']) }} style={{ 'backgroundColor': output['isComplete'] == true ? '#90ee90' : 'white' }} >
                                <td style={{ width: '2.7%', fontSize: '13px' }}><b>{data['jobID']}</b></td>
                                <td style={{ width: '100%', overflow: 'auto', fontSize: '13px' }}><b >{data['companyEN'] || this.renderCompany(data['companyID'])}</b></td>
                                <td style={{ width: '2.7%', overflow: 'auto', height: '100%', fontSize: '13px' }}><b>{data['surveyLocateName']} - {data['surveyProvince']}</b></td>
                                <td style={{ width: '7.7%', fontSize: '13px' }}><b>{data['shippingTime']} น.</b></td>
                                <td style={{ overflow: 'auto', width: '7.7%', fontSize: '13px' }}><b>{data['description'][idx]['vehicleName'] || data['description'][idx][`vehicleName${idx}`]}</b></td>
                                <td style={{ overflow: 'auto', width: '7.7%', fontSize: '13px' }}><b>{data['description'][idx]['destinationCity']}</b></td>
                                <td style={{ overflow: 'auto', fontSize: '13px' }}><b>{data['description'][idx]['licenseID'].slice(6, data['description'][idx]['licenseID'].length)}</b></td>
                                <td style={{ width: '2.7%', fontSize: '13px' }}><b>{parseInt(data['description'][idx]['subID']) + 1}</b></td>
                                <td style={{ width: '7.7%', fontSize: '13px' }}><b>{data['description'][idx]['riceTypeName'] || convertRiceTypeENToTH(data['description'][idx]['riceTypeID'], this.state.riceTypeIDAndName, 'standalone')}</b></td>
                                <td style={{ width: '7.7%', fontSize: '13px' }} style={{ width: '7.7%', fontSize: '13px' }}><b>{addCommaInNumber(this.renderQuantity(data, idx))}</b> <br /> </td>
                              </tr>
                            )
                          }))
                        }
                      })
                    }
                  })()
                  }
                </tbody>
              </Table>
            </Col>
          </Row>



        </Container>
      )
    }
    else {
      return (<Container>
        <AdminNav></AdminNav>
        <Loading />
      </Container>)
    }
  }
}


export default withRouter(CheckWeightTable);
